import React from "react"

import PropTypes from "prop-types"

import Link from "../Link/link"

import "./style.scss"

/**
 * Liens d'accès rapide pour l'accessibilité, visibles seulement au focus
 */
const AccessibilityLinks = ({linksProps}) =>
    linksProps.map(linkProps => {
        if (linkProps.href) {
            return (
                <Link className="accessibility-link" href={`#${linkProps.href}`}>
                    {linkProps.label}
                </Link>
            )
        }
        if (linkProps.onClick) {
            return (
                <Link className="accessibility-link" onClick={linkProps.onClick}>
                    {linkProps.label}
                </Link>
            )
        }
        return undefined
    })

AccessibilityLinks.propTypes = {
    linksProps: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            href: PropTypes.string,
            onClick: PropTypes.string,
        }),
    ).isRequired,
}

export default AccessibilityLinks
